<template>
  <transition name="modal" mode="in-out">
    <div class="app-modal" @click="$emit('modalClick')">
      <div class="app-modal-background" @click="showCloseButton ? $emit('closed') : null" />
      <div class="app-modal-container" :class="{ 'app-modal-container-large': large }">
        <div class="app-modal-header">
          <slot name="header">
            <div v-if="title" class="app-modal-title">
              <h3>{{ title }}</h3>
            </div>
            <div class="app-modal-close">
              <img v-if="showCloseButton" src="@/assets/icons/cancel.svg" alt="close modal" @click="$emit('closed')">
            </div>
          </slot>
        </div>

        <!--  Modal window body  -->
        <div class="app-modal-body" :class="{ 'app-modal-body-large': large }">
          <slot name="body" />
        </div>

        <!--  Modal window footer  -->
        <div v-if="$slots.footer" class="app-modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: {
      type: String,
      default: null
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  emits: ['modalClick', 'closed']
}
</script>

<style lang="scss">
.app-modal-body .form-generator-button,
.app-modal-footer .form-generator-button {
  background-color: rgb(var(--button-modal-background-color));
  color: rgb(var(--button-modal-color));
  width: calc(100% - (2 * var(--button-modal-margin)));
  margin: var(--button-modal-margin);
  padding: 0 1rem;
}
</style>

<style lang="scss" scoped>
.app-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 300;
  animation: open-modal 0.2s;

  .app-modal-background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(10 10 10 / 86%);
    z-index: 310;
  }

  .app-modal-container {
    position: relative;
    width: 95%;
    max-height: 82vh;
    background-color: rgb(var(--primary-color));
    z-index: 320;
    display: grid;
    grid-template-rows: 1fr auto minmax(1rem, max-content);

    /* Tablet (portrait) */
    @media only screen and (width >=768px) {
      width: 50%;
    }

    /* Desktops and laptops */
    @media only screen and (width >=1024px) {
      width: 45%;
    }

    /* Large screens */
    @media only screen and (width >=1824px) {
      width: 40%;
    }

    /* Large screens (portrait) */
    @media only screen and (orientation: portrait) and (width >=1080px) {
      width: 80%;
    }

    .app-modal-header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 1rem;
      position: relative;
      background-color: rgb(var(--primary-color));

      /* Large screens (portrait) */
      @media only screen and (orientation: portrait) and (width >=1080px) {
        padding: 3rem 4rem;
      }

      .app-modal-title {
        padding: 0 1.5rem;

        /* Tablet (portrait) */
        @media only screen and (width >=768px) {
          padding: 0 1.5rem;
        }

        /* Desktops and laptops */
        @media only screen and (width >=1024px) {
          padding: 0 2rem;
        }

        /* Large screens */
        @media only screen and (width >=1824px) {
          padding: 0 2.5rem;
        }
      }

      .app-modal-close {
        position: absolute;
        right: 1rem;
        top: 1rem;
        height: 1rem;
        width: 1rem;
        cursor: pointer;

        /* Large screens (portrait) */
        @media only screen and (orientation: portrait) and (width >=1080px) {
          right: 3rem;
          top: 3rem;
          height: 1.5rem;
          width: 1.5rem;
        }

        button {
          height: 100%;
          width: 100%;

          img {
            height: 100%;
            width: 100%;
          }
        }
      }
    }

    .app-modal-body {
      padding: 0 1rem;
      overflow: scroll;
    }

    .app-modal-body-large {
      padding: 0 !important;
    }

    .app-modal-footer {
      padding: 0 1rem;
      margin: 1rem 0;
      width: 100%;
    }
  }

  .app-modal-container-large {

    /* Tablet (portrait) */
    @media only screen and (width >=768px) {
      width: 90% !important;
    }

    /* Desktops and laptops */
    @media only screen and (width >=1024px) {
      width: 80% !important;
    }

    /* Large screens */
    @media only screen and (width >=1824px) {
      width: 75% !important;
    }

    /* Large screens (portrait) */
    @media only screen and (orientation: portrait) and (width >=1080px) {
      width: 95% !important;
    }
  }
}

select {
  appearance: none;
}

/* ANIM MODAL */
.modal-enter-active {
  transition: all 0.2s ease;
  opacity: 1;
  transform: scale(1);
}

.modal-enter,
.modal-leave-to {
  transition: all 0.2s ease;
  transform: scale(1.1);
  opacity: 0;
}

@keyframes open-modal {
  0% {
    opacity: 0;
    transform: scale(1.1);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
